import React from "react";
import { Helmet } from "react-helmet-async";
import { injectIntl, IntlShape } from "react-intl";
import { match as Match } from "react-router-dom";
import { withTwoColLayout } from "../../../../../../utils";
import PageSubheader from "../../../../../../components/PageSubheader";
import Form from "../form";

interface Props {
  match: Match<{ cid: string; typeId: string }>;
  intl: IntlShape;
  backURL: string;
}

const CreateCheckpoint = (props: Props) => {
  const { intl, backURL } = props;

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({
            id: "page.inspection.checkpoint.create.document.title",
          })}
        </title>
      </Helmet>

      <PageSubheader
        goBackEnabled
        goBackId="btn-back-inspection-checkpoint-create"
        goBackURL={backURL}
      />

      <Form {...props} edition={false} />
    </>
  );
};

export default withTwoColLayout(injectIntl(CreateCheckpoint));
